import { handleActions } from "redux-actions";
import { MERCHANT } from "constants/action-types";
import { IQuery, IMutate, RequestStatus } from "constants/crud";
import {
    GetMerchantDefaultItemRequestAction,
    GetMerchantDefaultItemCompleteAction,
    UpdateMerchantDefaultItemRequestAction,
    UpdateMerchantDefaultItemCompleteAction,
    CreateMerchantDefaultItemCompleteAction,
} from "actions/merchant";
import { IGridItem } from "constants/product-collection";

export interface IState extends IQuery<IGridItem>, IMutate<IGridItem> {}

const initialState: IState = {
    queryError: undefined,
    queryStatus: RequestStatus.Active,
    mutateStatus: RequestStatus.Idle,
    mutateError: undefined,
    result: undefined,
};

export const merchantDefaultItem = handleActions<IState, any>(
    {
        [MERCHANT.DEFAULT_ITEM.GET.REQUEST]: (state: IState, _action: GetMerchantDefaultItemRequestAction): IState => {
            return {
                ...state,
                ...initialState,
            };
        },
        [MERCHANT.DEFAULT_ITEM.GET.COMPLETE]: (state: IState, action: GetMerchantDefaultItemCompleteAction): IState => {
            return {
                ...state,
                queryStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                queryError: action.payload instanceof Error ? action.payload : undefined,
                result: action.payload instanceof Error ? undefined : action.payload,
            };
        },
        [MERCHANT.DEFAULT_ITEM.UPDATE.REQUEST]: (
            state: IState,
            _action: UpdateMerchantDefaultItemRequestAction
        ): IState => {
            return {
                ...state,
                mutateStatus: RequestStatus.Active,
                mutateError: undefined,
            };
        },
        [MERCHANT.DEFAULT_ITEM.CREATE.COMPLETE]: (
            state: IState,
            action: CreateMerchantDefaultItemCompleteAction
        ): IState => {
            return {
                ...state,
                mutateError: action.payload instanceof Error ? action.payload : undefined,
                mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                result: action.payload instanceof Error ? undefined : action.payload,
            };
        },
        [MERCHANT.DEFAULT_ITEM.UPDATE.COMPLETE]: (
            state: IState,
            action: UpdateMerchantDefaultItemCompleteAction
        ): IState => {
            return {
                ...state,
                mutateError: action.payload instanceof Error ? action.payload : undefined,
                mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                result: action.payload instanceof Error ? undefined : action.payload,
            };
        },
    } as any,
    initialState
);
